import axios from "../../utils/axiosInstance";

export const createDistributorSubgroupReactive = async (parentDistributorPartnerGroupId, groupName, adminUsernamesToAddToGroup, isReseller, isReferralAgent, canCreatePOC,
                                                        resellerDiscount, referralDiscount, daysUntilInvoiceDue, partnerMaxDaysForPOCTrialLicensesToExpire, canViewVolumeDiscounts,
                                                        twoYearAnnualDealDiscount, threeYearAnnualDealDiscount, twoYearPaidUpFrontDealDiscount, threeYearPaidUpFrontDealDiscount, canUseMonthlyPricing) => {
    return await axios.post("/createDistributorSubgroupReactive", {
        parentDistributorPartnerGroupId: parentDistributorPartnerGroupId,
        groupName: groupName,
        adminUsernamesToAddToGroup: adminUsernamesToAddToGroup,
        isReseller: isReseller,
        isReferralAgent: isReferralAgent,
        canCreatePOC: canCreatePOC,
        resellerDiscount: resellerDiscount,
        referralDiscount: referralDiscount,
        daysUntilInvoiceDue: daysUntilInvoiceDue,
        partnerMaxDaysForPOCTrialLicensesToExpire: partnerMaxDaysForPOCTrialLicensesToExpire,
        canViewVolumeDiscounts: canViewVolumeDiscounts,
        twoYearAnnualDealDiscount: twoYearAnnualDealDiscount,
        threeYearAnnualDealDiscount: threeYearAnnualDealDiscount,
        twoYearPaidUpFrontDealDiscount: twoYearPaidUpFrontDealDiscount,
        threeYearPaidUpFrontDealDiscount: threeYearPaidUpFrontDealDiscount,
        canUseMonthlyPricing: canUseMonthlyPricing
    });
};
export const promoteExistingGroupToSubgroupReactive = async (parentDistributorPartnerGroupId, groupIdToPromoteToSubgroup, isReseller, isReferralAgent, canCreatePOC,
                                                             resellerDiscount, referralDiscount, daysUntilInvoiceDue, partnerMaxDaysForPOCTrialLicensesToExpire, canViewVolumeDiscounts,
                                                             twoYearAnnualDealDiscount, threeYearAnnualDealDiscount, twoYearPaidUpFrontDealDiscount, threeYearPaidUpFrontDealDiscount, canUseMonthlyPricing) => {
    return await axios.post("/promoteExistingGroupToSubgroupReactive", {
        parentDistributorPartnerGroupId: parentDistributorPartnerGroupId,
        groupIdToPromoteToSubgroup: groupIdToPromoteToSubgroup,
        isReseller: isReseller,
        isReferralAgent: isReferralAgent,
        canCreatePOC: canCreatePOC,
        resellerDiscount: resellerDiscount,
        referralDiscount: referralDiscount,
        daysUntilInvoiceDue: daysUntilInvoiceDue,
        partnerMaxDaysForPOCTrialLicensesToExpire: partnerMaxDaysForPOCTrialLicensesToExpire,
        canViewVolumeDiscounts: canViewVolumeDiscounts,
        twoYearAnnualDealDiscount: twoYearAnnualDealDiscount,
        threeYearAnnualDealDiscount: threeYearAnnualDealDiscount,
        twoYearPaidUpFrontDealDiscount: twoYearPaidUpFrontDealDiscount,
        threeYearPaidUpFrontDealDiscount: threeYearPaidUpFrontDealDiscount,
        canUseMonthlyPricing: canUseMonthlyPricing
    });
};

export const subgroupTurnChannelPartnerSettingOffReactive = async (zenGroupId) => {
    return await axios.post("/subgroupTurnChannelPartnerSettingOffReactive", {
        zenGroupId: zenGroupId
    });
};
export const changeSubgroupIsResellerReactive = async (zenGroupId, newSetting) => {
    return await axios.post("/changeSubgroupIsResellerReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting
    });
};
export const changeSubgroupIsReferralAgentReactive = async (zenGroupId, newSetting) => {
    return await axios.post("/changeSubgroupIsReferralAgentReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting
    });
};
export const changeSubgroupCanCreatePOCReactive = async (zenGroupId, newSetting) => {
    return await axios.post("/changeSubgroupCanCreatePOCReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting
    });
};
export const changeSubgroupCanViewVolumeDiscountsReactive = async (zenGroupId, newSetting) => {
    return await axios.post("/changeSubgroupCanViewVolumeDiscountsReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting
    });
};

export const changeSubgroupCanUseMonthlyPricingReactive = async (zenGroupId, newSetting) => {
    return await axios.post("/changeSubgroupCanUseMonthlyPricingReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting
    });
};

export const changeSubgroupResellerDiscountReactive = async (zenGroupId, newDiscount) => {
    return await axios.post("/changeSubgroupResellerDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount
    });
};

export const changeSubGroupTwoYearAnnualDealDiscountReactive = async (zenGroupId, newDiscount) => {
    return await axios.post("/changeSubGroupTwoYearAnnualDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount
    });
};
export const changeSubGroupThreeYearAnnualDealDiscountReactive = async (zenGroupId, newDiscount) => {
    return await axios.post("/changeSubGroupThreeYearAnnualDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount
    });
};
export const changeSubGroupTwoYearPaidUpFrontDealDiscountReactive = async (zenGroupId, newDiscount) => {
    return await axios.post("/changeSubGroupTwoYearPaidUpFrontDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount
    });
};
export const changeSubGroupThreeYearPaidUpFrontDealDiscountReactive = async (zenGroupId, newDiscount) => {
    return await axios.post("/changeSubGroupThreeYearPaidUpFrontDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount
    });
};

export const changeSubgroupReferralAgentDiscountReactive = async (zenGroupId, newDiscount) => {
    return await axios.post("/changeSubgroupReferralAgentDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount
    });
};

export const changeSubgroupDaysUntilInvoiceDueReactive = async (zenGroupId, newDaysUntilDue) => {
    return await axios.post("/changeSubgroupDaysUntilInvoiceDueReactive", {
        zenGroupId: zenGroupId,
        newDaysUntilDue: newDaysUntilDue
    });
};

export const changeSubgroupMaxDaysUntilTrialLicensesExpireReactive = async (zenGroupId, partnerMaxDaysForPOCTrialLicensesToExpire) => {
    return await axios.post("/changeSubgroupMaxDaysUntilTrialLicensesExpireReactive", {
        zenGroupId: zenGroupId,
        partnerMaxDaysForPOCTrialLicensesToExpire: partnerMaxDaysForPOCTrialLicensesToExpire
    });
};

export const removeSubgroupFromParentDistributorReactive = async (zenGroupId) => {
    return await axios.post("/removeSubgroupFromParentDistributorReactive", {
        zenGroupId: zenGroupId
    });
};

export const getGroupsWithoutParentPartnerAssignedReactive = async () => {
    const response = await axios.post("/getGroupsWithoutParentPartnerAssignedReactive",{})
    return response.data
}

export const getDistributorManagementGridFilterStateReactive = async () => {
    const response =  await axios.post("/getDistributorManagementGridFilterStateReactive", {});
    return response.data;
};

export const updateDistributorManagementGridFilterModelReactive = async (newFilterModel) => {
    return await axios.post("/updateDistributorManagementGridFilterModelReactive", {
        newFilterModel: newFilterModel
    });
};

export const updateDistributorManagementGridUseFilterStateReactive = async (newUseFilterState) => {
    return await axios.post("/updateDistributorManagementGridUseFilterStateReactive", {
        newUseFilterState: newUseFilterState
    });
};

export const getDistributorManagementGridColumnStateReactive = async () => {
    const response =  await axios.post("/getDistributorManagementGridColumnStateReactive", {});
    return response.data;
};
export const updateDistributorManagementGridColumnStateReactive = async (columnStatesList) => {
    return await axios.post("/updateDistributorManagementGridColumnStateReactive", {
        columnStatesList: columnStatesList
    });
};

export const updateDistributorManagementGridUseColumnStateReactive = async (newUseColumnState) => {
    return await axios.post("/updateDistributorManagementGridUseColumnStateReactive", {
        newUseColumnState: newUseColumnState
    });
};

export const updateDistributorManagementGridColumnModeReactive = async (columnMode) => {
    return await axios.post("/updateDistributorManagementGridColumnModeReactive", {
        columnMode: columnMode
    });
};

export const uploadSignedResellerAgreementReactive = async (parentDistributorGroupId, subgroupId, signedAgreementPDF) => {
    //have to take some extra steps in this request since we are sending a file along with partnerDealId
    const formData = new FormData()
    formData.append('signedAgreementPDF', signedAgreementPDF)
    formData.append('parentDistributorGroupId', parentDistributorGroupId)
    formData.append('subgroupId', subgroupId)
    const config  = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return await axios.post("/uploadSignedResellerAgreementReactive", formData, config);
};
export const getSignedResellerAgreementReactive = async (subgroupId) => {
    const response =  await axios.post("/getSignedResellerAgreementReactive", {
        subgroupId: subgroupId
    });
    return response.data;
};